import { useContext } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { NotificationContext } from 'context/NotificationContext';

import styles from './AddDisclosures.module.less';

const AddDisclosures = ({
  onSave,
  title,
}: {
  onSave: () => void;
  title: string;
}) => {
  const notificationFlag = useContext(NotificationContext);

  return (
    <div className={styles.addOrRemovePlansWrapper}>
      <div className={styles.header}>
        <div>
          <PlusCircleOutlined className={styles.addIcon} />
        </div>
        <div>
          <div className={styles.title}>{title}</div>
          <div className={styles.noPlansHeader}>
            Add benefits disclosures here
          </div>
        </div>
      </div>
      <div className={styles.buttons}>
        <Button
          disabled={notificationFlag}
          className={styles.addButton}
          onClick={onSave}
        >
          Add Disclosures
        </Button>
      </div>
    </div>
  );
};

export default AddDisclosures;
